import React from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Accuracy_Form.css";

function Accuracy_Form({ onProceed }) {
  const verificationOptions = [
    { value: "crm", label: "Use Of CRM" },
    { value: "internal", label: "Internal Verification" },
  ];

  const parameters = ["ASH%", "VM%", "Moist", "GCV"];

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">

        {/* ================= TOP ROW ================= */}
        <div className="row">
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Type Of Verification</Form.Label>
              <Select
                options={verificationOptions}
                placeholder="Select Type"
                classNamePrefix="react_select"
              />
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Certified Value</Form.Label>
              <Form.Control placeholder="Certified Value" />
            </Form.Group>
          </div>
        </div>

        {/* ================= INNER SECTION ================= */}
        <div className="inner_form_section_holder">

          {/* ===== Certified Value Parameter ===== */}
          <div className="row">
            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Certified Value Parameter</Form.Label>
              </Form.Group>
            </div>

            {parameters.map((label, index) => (
              <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-3" key={index}>
                <div className="observation_box">
                  <div className="obs_label">{label}</div>
                  <div className="form_field_holder">
                    <Form.Control />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ===== Result Value ===== */}
          <div className="row mt-3">
            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Result Value</Form.Label>
              </Form.Group>
            </div>

            {parameters.map((label, index) => (
              <div className="col-xxl-1 col-xl-1 col-lg-2 col-md-3" key={index}>
                <div className="observation_box">
                  <div className="obs_label">{label}</div>
                  <div className="form_field_holder">
                    <Form.Control />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ===== Accuracy Acceptance ===== */}
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Accuracy Acceptance</Form.Label>
                <Form.Check type="checkbox" label="Accepted" defaultChecked />
              </Form.Group>
            </div>
          </div>

        </div>

        {/* ================= FOOTER ================= */}
        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn">Cancel</Button>
          <Button className="permission_btn Yes_btn" onClick={onProceed}>
            Save
          </Button>
        </div>

      </div>
    </section>
  );
}

export default Accuracy_Form;
